/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ChangeEvent } from 'react';
import { UseFormRegister } from 'react-hook-form';
import { Typography, TFontWeight } from '../Typography/Typography';

import styles from './Checkbox.module.scss';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface ICheckbox {
  label?: string;
  indeterminate?: boolean;
  defaultChecked?: boolean;
  required?: boolean;
  disabled?: boolean;
  alignment?: 'center' | 'baseline';
  labelWeight?: TFontWeight;
}

interface IControlledCheckboxProps extends ICheckbox {
  checked: boolean;
  name?: string;
  register?: never;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

interface IUncontrolledCheckboxProps extends ICheckbox {
  checked?: never;
  name: string;
  register: UseFormRegister<any>;
  onChange?: never;
}

export type TCheckboxProps = IControlledCheckboxProps | IUncontrolledCheckboxProps;

const Checkbox = ({
  indeterminate = false,
  label,
  checked,
  defaultChecked,
  name,
  register,
  onChange,
  disabled = false,
  required = false,
  alignment = 'center',
  labelWeight = 'semi-bold',
  ...rest
}: TCheckboxProps) => {
  return (
    <span>
      <label
        className={cx('label', {
          [`label-${alignment}`]: alignment,
        })}
      >
        <span className={styles['checkbox']}>
          <input
            className={styles['input']}
            type="checkbox"
            aria-label={label}
            checked={checked}
            defaultChecked={defaultChecked}
            onChange={onChange}
            disabled={disabled}
            {...(register && register(name, { required }))}
            {...rest}
          />
          <span
            className={cx('checkmark', {
              'is-indeterminate': indeterminate,
              'is-tick': !indeterminate,
            })}
          />
        </span>
        <Typography size="M" weight={labelWeight}>
          {label}
        </Typography>
      </label>
    </span>
  );
};

export default Checkbox;
